'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

var _iconClock = require('../icons/icon-clock');

var _iconClock2 = _interopRequireDefault(_iconClock);

var _iconEmoji = require('../icons/icon-emoji');

var _iconEmoji2 = _interopRequireDefault(_iconEmoji);

var _iconNature = require('../icons/icon-nature');

var _iconNature2 = _interopRequireDefault(_iconNature);

var _iconFood = require('../icons/icon-food');

var _iconFood2 = _interopRequireDefault(_iconFood);

var _iconActivity = require('../icons/icon-activity');

var _iconActivity2 = _interopRequireDefault(_iconActivity);

var _iconTravel = require('../icons/icon-travel');

var _iconTravel2 = _interopRequireDefault(_iconTravel);

var _iconObjects = require('../icons/icon-objects');

var _iconObjects2 = _interopRequireDefault(_iconObjects);

var _iconSymbols = require('../icons/icon-symbols');

var _iconSymbols2 = _interopRequireDefault(_iconSymbols);

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  changeCategory: _propTypes2.default.func.isRequired,
  category: _propTypes2.default.string.isRequired,
  activeColor: _propTypes2.default.string.isRequired,
  recent: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  iconStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  iconColor: _propTypes2.default.string.isRequired
};

var defaultProps = {
  style: {},
  iconStyle: {}
};

var EmojiCategories = function EmojiCategories(_ref) {
  var changeCategory = _ref.changeCategory,
      category = _ref.category,
      activeColor = _ref.activeColor,
      recent = _ref.recent,
      style = _ref.style,
      iconStyle = _ref.iconStyle,
      iconColor = _ref.iconColor;
  return _react2.default.createElement(
    'footer',
    { style: _getStyles2.default.categories(style) },
    recent ? _react2.default.createElement(
      'div',
      {
        style: _getStyles2.default.categoriesCategory(iconStyle),
        onClick: function onClick() {
          return changeCategory('recent');
        }
      },
      _react2.default.createElement(_iconClock2.default, { color: category === 'recent' ? activeColor : iconColor })
    ) : null,
    _react2.default.createElement(
      'div',
      { style: _getStyles2.default.categoriesCategory(iconStyle), onClick: function onClick() {
          return changeCategory('people');
        } },
      _react2.default.createElement(_iconEmoji2.default, { color: category === 'people' ? activeColor : iconColor })
    ),
    _react2.default.createElement(
      'div',
      { style: _getStyles2.default.categoriesCategory(iconStyle), onClick: function onClick() {
          return changeCategory('nature');
        } },
      _react2.default.createElement(_iconNature2.default, { color: category === 'nature' ? activeColor : iconColor })
    ),
    _react2.default.createElement(
      'div',
      { style: _getStyles2.default.categoriesCategory(iconStyle), onClick: function onClick() {
          return changeCategory('food');
        } },
      _react2.default.createElement(_iconFood2.default, { color: category === 'food' ? activeColor : iconColor })
    ),
    _react2.default.createElement(
      'div',
      { style: _getStyles2.default.categoriesCategory(iconStyle), onClick: function onClick() {
          return changeCategory('activity');
        } },
      _react2.default.createElement(_iconActivity2.default, { color: category === 'activity' ? activeColor : iconColor })
    ),
    _react2.default.createElement(
      'div',
      { style: _getStyles2.default.categoriesCategory(iconStyle), onClick: function onClick() {
          return changeCategory('travel');
        } },
      _react2.default.createElement(_iconTravel2.default, { color: category === 'travel' ? activeColor : iconColor })
    ),
    _react2.default.createElement(
      'div',
      { style: _getStyles2.default.categoriesCategory(iconStyle), onClick: function onClick() {
          return changeCategory('objects');
        } },
      _react2.default.createElement(_iconObjects2.default, { color: category === 'objects' ? activeColor : iconColor })
    ),
    _react2.default.createElement(
      'div',
      { style: _getStyles2.default.categoriesCategory(iconStyle), onClick: function onClick() {
          return changeCategory('symbols');
        } },
      _react2.default.createElement(_iconSymbols2.default, { color: category === 'symbols' ? activeColor : iconColor })
    )
  );
};

EmojiCategories.propTypes = propTypes;
EmojiCategories.defaultProps = defaultProps;

exports.default = (0, _radium2.default)(EmojiCategories);
module.exports = exports.default;